import React, { useState, useEffect } from "react";
import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import { SBADropDown, SBAMultiSelect } from "../../../UiComponents/SBADropDown";

function RecommendationsWid({ data, familiesList, portfolioList, family }) {
  // const [selectedFamily, setSelectedFamily] = useState(family);
  // useEffect(() => {
  //   setSelectedFamily(family)
  // }, [family]);
  // console.log(family,'family')
  const [selectedPortfolio, setSelectedPortfolio] = useState([]);
  const [selectedRecButton, setSelectedRecButton] = useState(0);

  const getDateFormatted = (params) => {
    const isoDate = params.value;
    const formattedDate = moment(isoDate).format("MM-DD-YYYY");
    return formattedDate;
  };
  const handleSelectedPortfolio = (e) => {
    setSelectedPortfolio(e.value);
  };

  const FormatCurrencyGrid = (params, fieldName) => {
    var num = params.data[fieldName];
    if (num !== undefined) {
      const isNegative = num < 0;

      const formattedValue = isNegative
        ? `($${Math.abs(num).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })})`
        : `$${num.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}`;
      const style = isNegative ? { color: 'red' } : null;

      return <span style={style}>{formattedValue}</span>;
    } else {
      return num;
    }
  };
  var trackerdefs = [
    {
      field: "PortfolioName",
      headerName: "Portfolio Name",
    },
    {
      field: "AssetName",
      headerName: "Asset Name",

    },
    {
      field: "TransactionDate",
      headerName: "Transaction Date",
      valueFormatter: getDateFormatted
    },
    {
      field: "TransactionAmount",
      headerName: "Transaction Amount",
      cellRenderer: (e) => { return FormatCurrencyGrid(e, "TransactionAmount") }
    },
    {
      field: "Notes",
      headerName: "Notes",
    },

  ];

  const defaultColDef = {
    sortable: true, filter: true, floatingFilter: true, flex: 1, filter: 'agTextColumnFilter', resizable: true
  };
  const recommendButtons = ["Approved", "Proposed", "Rejected"];
  const recButtonClick = (index) => {
    setSelectedRecButton(index);
  }
  return (
    <>
      <div className="k-tilelayout-item k-card k-cursor-grab h-100">
        <>
          <div className="k-tilelayout-item-header k-card-header">
            <div>
              <div className="header-container">
                <b>Recommendation (Last 12 months)</b>
                <div className="col-md-3">
                  <label className="label">Family</label>
                  <div>
                    <SBADropDown
                      className="w-75"
                      textField={"FamilyName"}
                      valueField={"FamilyId"}
                      data={familiesList}
                      value={family}
                      disabled={true}
                    //  onChange={(e)=> }
                    >
                    </SBADropDown>
                  </div>
                </div>
                <div className='col-md-3' >
                  <label className='label'>Portfolio</label>
                  <div>
                    <SBAMultiSelect
                      className="w-100"
                      data={portfolioList}
                      textField={"EntityName"}
                      valueField={"EntityId"}
                      value={selectedPortfolio}
                      onChange={handleSelectedPortfolio}
                      popupSettings={{ className: "modalDD" }}
                    ></SBAMultiSelect>
                  </div>
                </div>
                <div className="button-container" style={{ top: '10px' }}>
                  {recommendButtons.map((name, index) => (
                    <button
                      key={index}
                      className={selectedRecButton === index ? "selected-non-gappable-button p-2" : "non gappable-button p-2"}
                      onClick={() => recButtonClick(index)}
                    >
                      {name}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
        <div className="k-tilelayout-item-body k-card-body">
        <div className="ag-theme-alpine m-1 " style={{ height: 330 }}>
          <AgGridReact
            columnDefs={trackerdefs}
            rowData={data}
            defaultColDef={defaultColDef}
            enableBrowserTooltips={true}
            tooltipInteraction={true}
            pagination={true}
            paginationPageSize={10}
          //onRowDoubleClicked={(e) => { addpopup(e.data, 'InvestorTracking') }}
          />
        </div>
        </div>
      </div>
    </>
  );
}

export default RecommendationsWid;